import * as React from 'react';
import { Link } from 'react-router-dom';

import { FilterParamsModel, TitleStat } from '../common/models';

interface TitleLinkProps {
  titleStat: TitleStat;
}

export const TitleStatLink = ({ titleStat }: TitleLinkProps) => {
  const filters = FilterParamsModel.create({ title: titleStat.title });
  return (
    <Link to={`/unit/${titleStat.unitId}?${filters.toQueryString()}`} key={titleStat.title}>
      <h3>{titleStat.title} <small>({titleStat.timesUsed})</small></h3>
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/TitlesUsedView/TitleStatLink.tsx